import { api } from '../../constants/api.js';
import { axios } from "../http/axios";

const MetricsService = {
    fetchMetrics: async (timeframe = '7D', startDate = null, endDate = null) => {
        try {
            const response = await axios.get(api.metrics.fetch, {
                params: {
                    timeframe,        
                    startDate: startDate ? startDate.toISOString() : undefined,
                    endDate: endDate ? endDate.toISOString() : undefined,
                }
            });
            const metrics = response.data.metrics || [];
            const totalRevenue = response.data.totalRevenue || 0;

            if (!Array.isArray(metrics)) {
                throw new Error('Invalid metrics data format');
            }

            return {
                metrics,
                totalRevenue,
                storeVisits: metrics.reduce((acc, metric) => acc + metric.visits, 0),
                leads: metrics.reduce((acc, metric) => acc + metric.emailLeads, 0),
            };
        } catch (error) {
            console.error('Failed to fetch metrics:', error);
            throw error;
        }
    },

    fetchMetricsByRange: async (startDate, endDate) => {
        try {
            const response = await axios.get(api.metrics.fetch, {
                params: {
                    startDate: startDate.toISOString(),
                    endDate: endDate.toISOString()
                }
            });

            return response.data.metrics || [];
        } catch (error) {
            console.error('Failed to fetch metrics by range:', error);
            throw error;
        }
    }
};

export default MetricsService;